import imageCompareViewer from 'image-compare-viewer'

document.addEventListener('DOMContentLoaded', function () {
    const element = document.getElementsByClassName('js-progress-image-compare')[0]

    if (element) {
        new imageCompareViewer(element,{
            verticalMode: false,
            fluidMode: true,
            hoverStart: true,
            addCircle: true,
            addCircleBlur: true,
            smoothing: true,
            smoothingAmount: 100,
            startingPoint: 75,
            controlColor: "#ec144c",
            showLabels: true,
            labelOptions: {
                before: element.children[0].alt,
                after: element.children[1].alt,
                onHover: false
            },
        }).mount();
    }
})
